import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { UpdateDocumentAdditionalData } from "./UpdateDocumentAdditionalData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

export const updateDocumentMustReadRemindActionTypes = createRequestActionTypes('UPDATE_DOCUMENT_MUST_READ_USERS')

type UpdateDocumentMustReadRemindRequestBody = {
    UsersIds: string[]
}

export const updateDocumentMustReadRemind = (config: ApiConfig) => (docId: string, membersUUIDs: string[]) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document, UpdateDocumentMustReadRemindRequestBody, UpdateDocumentAdditionalData> = {
        method: 'PUT',
        requestActionTypes: updateDocumentMustReadRemindActionTypes,
        url: `${config.API_URL}/mustRead/remind/${encodeURIComponent(docId)}`,
        actionAdditionalData: {
            docId
        },
        processResultBeforeDispatch: (doc: Document) => {

            if (config.updateItem) {
                config.updateItem(docId)
            }

            return doc
        },

        body: { UsersIds: membersUUIDs }
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}